// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/delayedack/tx.proto (package dymensionxyz.dymension.delayedack, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { RollappPacket_Type } from "./common/rollapp_packet_pb.js";

/**
 * MsgFinalizePacket finalizes a single packet.
 *
 * @generated from message dymensionxyz.dymension.delayedack.MsgFinalizePacket
 */
export class MsgFinalizePacket extends Message<MsgFinalizePacket> {
  /**
   * Sender is the signer of the message.
   *
   * @generated from field: string sender = 1;
   */
  sender = "";

  /**
   * RollappID is the ID of the rollapp.
   *
   * @generated from field: string rollapp_id = 2;
   */
  rollappId = "";

  /**
   * PacketProofHeight is a height at which the proof was retrieved.
   *
   * @generated from field: uint64 packet_proof_height = 3;
   */
  packetProofHeight = protoInt64.zero;

  /**
   * PacketType is a type of the packet. Eg, RECV, ACK, TIMEOUT.
   *
   * @generated from field: dymensionxyz.dymension.common.RollappPacket.Type packet_type = 4;
   */
  packetType = RollappPacket_Type.ON_RECV;

  /**
   * PacketSrcChannel identifies the channel end on the sending chain.
   *
   * @generated from field: string packet_src_channel = 5;
   */
  packetSrcChannel = "";

  /**
   * PacketSequence is a sequence number of the packet.
   *
   * @generated from field: uint64 packet_sequence = 6;
   */
  packetSequence = protoInt64.zero;

  constructor(data?: PartialMessage<MsgFinalizePacket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.delayedack.MsgFinalizePacket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "packet_proof_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "packet_type", kind: "enum", T: proto3.getEnumType(RollappPacket_Type) },
    { no: 5, name: "packet_src_channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "packet_sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFinalizePacket {
    return new MsgFinalizePacket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFinalizePacket {
    return new MsgFinalizePacket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFinalizePacket {
    return new MsgFinalizePacket().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFinalizePacket | PlainMessage<MsgFinalizePacket> | undefined, b: MsgFinalizePacket | PlainMessage<MsgFinalizePacket> | undefined): boolean {
    return proto3.util.equals(MsgFinalizePacket, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.delayedack.MsgFinalizePacketResponse
 */
export class MsgFinalizePacketResponse extends Message<MsgFinalizePacketResponse> {
  constructor(data?: PartialMessage<MsgFinalizePacketResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.delayedack.MsgFinalizePacketResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFinalizePacketResponse {
    return new MsgFinalizePacketResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFinalizePacketResponse {
    return new MsgFinalizePacketResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFinalizePacketResponse {
    return new MsgFinalizePacketResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFinalizePacketResponse | PlainMessage<MsgFinalizePacketResponse> | undefined, b: MsgFinalizePacketResponse | PlainMessage<MsgFinalizePacketResponse> | undefined): boolean {
    return proto3.util.equals(MsgFinalizePacketResponse, a, b);
  }
}

/**
 * MsgFinalizePacketByPacketKey finalizes a single packet by the packet key.
 *
 * @generated from message dymensionxyz.dymension.delayedack.MsgFinalizePacketByPacketKey
 */
export class MsgFinalizePacketByPacketKey extends Message<MsgFinalizePacketByPacketKey> {
  /**
   * Sender is the signer of the message.
   *
   * @generated from field: string sender = 1;
   */
  sender = "";

  /**
   * PacketKey is a key of the packet.
   *
   * @generated from field: string packet_key = 2;
   */
  packetKey = "";

  constructor(data?: PartialMessage<MsgFinalizePacketByPacketKey>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.delayedack.MsgFinalizePacketByPacketKey";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "packet_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFinalizePacketByPacketKey {
    return new MsgFinalizePacketByPacketKey().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFinalizePacketByPacketKey {
    return new MsgFinalizePacketByPacketKey().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFinalizePacketByPacketKey {
    return new MsgFinalizePacketByPacketKey().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFinalizePacketByPacketKey | PlainMessage<MsgFinalizePacketByPacketKey> | undefined, b: MsgFinalizePacketByPacketKey | PlainMessage<MsgFinalizePacketByPacketKey> | undefined): boolean {
    return proto3.util.equals(MsgFinalizePacketByPacketKey, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.delayedack.MsgFinalizePacketByPacketKeyResponse
 */
export class MsgFinalizePacketByPacketKeyResponse extends Message<MsgFinalizePacketByPacketKeyResponse> {
  constructor(data?: PartialMessage<MsgFinalizePacketByPacketKeyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.delayedack.MsgFinalizePacketByPacketKeyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFinalizePacketByPacketKeyResponse {
    return new MsgFinalizePacketByPacketKeyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFinalizePacketByPacketKeyResponse {
    return new MsgFinalizePacketByPacketKeyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFinalizePacketByPacketKeyResponse {
    return new MsgFinalizePacketByPacketKeyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFinalizePacketByPacketKeyResponse | PlainMessage<MsgFinalizePacketByPacketKeyResponse> | undefined, b: MsgFinalizePacketByPacketKeyResponse | PlainMessage<MsgFinalizePacketByPacketKeyResponse> | undefined): boolean {
    return proto3.util.equals(MsgFinalizePacketByPacketKeyResponse, a, b);
  }
}

